import { Component, OnInit, AfterViewInit, OnDestroy, ChangeDetectorRef, Input } from '@angular/core';
import { AuftragEx, AuftragListItem } from 'src/app/api/model/model';
import { AuftragService } from 'src/app/api/auftrag.service';
import { UiHelper } from 'src/app/api/helper/ui-helper';
import { Subscription } from 'rxjs';
import { Logger } from 'src/app/api/helper/app-error-logger';
import { MyApp } from 'src/app/api/helper/app';
import { Auftragsstatus } from 'src/app/api/model/aufteagsstatus';

import { AppConfig } from 'src/app/api/helper/app.config';
import { RemoteService } from 'src/app/api/remote.service';
import { Router } from '@angular/router';
import { Utils } from 'src/app/api/helper/utils';

const log = new Logger("AuftragUnterauftraegeBeladungPage");

@Component({
    selector: 'app-auftrag-unterauftraege-beladung',
    templateUrl: './auftrag-unterauftraege-beladung.page.html',
    styleUrls: ['./auftrag-unterauftraege-beladung.page.scss'],
    standalone: false
})
export class AuftragUnterauftraegeBeladungPage implements OnInit, AfterViewInit, OnDestroy {

    @Input() auftrag: AuftragEx;
    @Input() unterauftraege: AuftragListItem[];

    laderaeume: LaderaumVO[] = [];
    subscriptions: Subscription[] = [];

    constructor(
        private router: Router,
        private auftragService: AuftragService,
        private cdr: ChangeDetectorRef,
        private remoteService: RemoteService) { }

    async ngOnInit() {
        if (!this.auftrag?.Ladeplan?.Laderaeume) {
            return;
        }

        this.laderaeume = [];

        for (const laderaum of this.auftrag.Ladeplan.Laderaeume) {
            const vo: LaderaumVO = {
                label: laderaum.Label,
                auftraege: []
            };

            if (!vo.label) {
                vo.label = laderaum.Nummer?.toString();
            }

            for (const packstueck of laderaum.Packstuecke) {
                const auftrag = this.unterauftraege.find(p => p.PaletteId === packstueck.Id);

                if (auftrag) {
                    vo.auftraege.push(auftrag);
                }
            }

            vo.auftraege.sort((a, b) => {
                if (a.stellplatzLkw < b.stellplatzLkw) {
                    return -1;
                } else if (a.stellplatzLkw > b.stellplatzLkw) {
                    return 1;
                }

                return 0;
            })

            this.laderaeume.push(vo);
        }

        this.cdr.detectChanges();
    }

    ngAfterViewInit(): void {
    }

    ngOnDestroy(): void {
    }

    istAnderemGeraetZugeordnet(unterauftrag: AuftragListItem) {
        return unterauftrag.Auftragsstatus >= Auftragsstatus.Zugewiesen
            && unterauftrag.Geraet !== AppConfig.current.geraeteNummer;
    }

    async onUnterauftragClicked(unterauftrag: AuftragListItem) {
        log?.debug('onUnterauftragClicked', unterauftrag.Key);

        this.router.navigateByUrl('/auftragsliste/details/' + unterauftrag.Key);
    }
}

interface LaderaumVO {
    label: string;
    auftraege: AuftragListItem[];
}